module.exports = __webpack_public_path__ + "assets/img/said.63d2e792.jpg";